import {
  getMyOrganization,
  getSubject,
  Reading,
  useDynamicSelector,
} from "@src/redux";
import { Image, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

type Props = {
  items: any;
};

const CustomTestDetails = (props: Props) => {
  const { items } = props;
  const getReadingDetails: { reading: Reading } = useDynamicSelector(
    "get_reading_details"
  );

  return (
    <>
      <div>
        {((getReadingDetails?.reading?.customTestList &&
          getReadingDetails?.reading?.customTestList?.length > 0) ||
          items?.length > 0) && (
          <div>
            {items?.map((group: any) => (
              <div key={group.id}>
                <h3>{group.name}</h3>
                <ul className="other-test-question-container">
                  {group.questions.map((question: any, qIndex: number) => (
                    <li key={qIndex}>
                      <strong>{`${question.name} ?`}</strong>
                      <br />
                      {question.type === "file" ? (
                        <Image src={question.value} width={100} />
                      ) : (
                        question.value
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default CustomTestDetails;
